export default __webpack_public_path__ + "locales/sk/PreparationPortal.json?hash=417ddb1ada8cb7843f5f32a840fbedc2";